import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/index.css';
import App from './App';
import { GoogleOAuthProvider } from "@react-oauth/google";
import { GameConfigProvider } from './context/GameConfig';
import { PendingReportsProvider } from './context/PendingReports';
import reportWebVitals from './reportWebVitals';
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import BugsnagPerformance from '@bugsnag/browser-performance'

const clientId = "465360270452-ig69k3lbngq9mv6aheqofg196ukpmqai.apps.googleusercontent.com";
let ErrorBoundary = React.Fragment; // Default to no-op if Bugsnag is disabled

// Initialize Bugsnag only in production
if (process.env.NODE_ENV === 'production') {
    Bugsnag.start({
        apiKey: '5bcfd9de5c42f90948c8dfd2e9653ca1',
        plugins: [new BugsnagPluginReact()],
    });
    BugsnagPerformance.start({ apiKey: '5bcfd9de5c42f90948c8dfd2e9653ca1' });
    ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <ErrorBoundary>
            <GoogleOAuthProvider clientId={clientId}>
                <GameConfigProvider>
                    <PendingReportsProvider>
                        <App />
                    </PendingReportsProvider>
                </GameConfigProvider>
            </GoogleOAuthProvider>
        </ErrorBoundary>
    </React.StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
